import { render, staticRenderFns } from "./ManagerFirstLogin.vue?vue&type=template&id=48d458d4&"
import script from "./ManagerFirstLogin.vue?vue&type=script&lang=js&"
export * from "./ManagerFirstLogin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports